
<template>
  <div class="container-fluid">
    
    <component is="style">


      .skin-editor.body {
      background: url({{BackGroundImage}}) no-repeat center center fixed !important;
      -webkit-background-size: cover !important;
      -moz-background-size: cover !important;
      -o-background-size: cover !important;
      background-size: cover !important;
      }

      .skin-editor.body {
      background-color: {{BackGroundColor}} !important;
      color: {{BodyColor}} !important;
      }

      .skin-editor .skin th a {
      color: {{BodyColor}} !important;
      }

      .skin-editor .custom-default-text {
      color: {{BodyColor}} !important;
      }

      .skin-editor .navbar-nav .dropdown-menu {
      background-color: {{TopMenuDropBackColor}} !important;
      }

      .skin-editor .custom-menubar-bg {
      background-color: {{TopMenuBackColor}} !important;
      color: {{MenuTextColor}} !important;
      }

      .skin-editor .custom-mobile-menu {
      background-color: {{MenuMobileColor}} !important;
      color: {{MenuTextColor}} !important;
      }

      .skin-editor .custom-item-bg {
      background-color: {{MenuColor}} !important;
      color: {{MenuTextColor}} !important;
      }

      .skin-editor .custom-neutral-item-bg {
      background-color: {{MenuColor}} !important;
      color: {{MenuTextColor}} !important;
      }

      .skin-editor .custom-item-bg:focus, .custom-item-bg:hover, .custom-neutral-item-bg:focus, .custom-neutral-item-bg:hover {
      background-color: {{MenuActiveColor}} !important;
      color: {{MenuActiveTextColor}} !important;
      }

      .skin-editor .custom-item-bg.active {
      background-color: {{MenuActiveColor}} !important;
      color: {{MenuActiveTextColor}} !important;
      text-decoration: underline !important;
      font-weight: bold;
      }

      .skin-editor .skin.adminmenu-bg {
      background-color: {{Admin_Menu_Color}} !important;
      }

      .skin-editor .sidebar-dark .nav-sidebar .nav-item-expanded {
      background-color: {{Admin_Menu_Selected_Color}} !important;
      }

      .skin-editor .sidebar-dark .nav-sidebar .nav-item {
      background-color: rgba(255,255,255,.07) !important;
      color: {{Light_Color_Text}} !important;
      }

      .skin-editor .sidebar-dark .nav-sidebar .nav-item > .nav-link.active {
      font-weight: bold;
      background-color: rgba(255,255,255,.05) !important;
      color: {{Light_Color_Text}} !important;
      }

      .skin-editor .skin.menu-bgcolor {
      background-color: {{MenuColor}} !important;
      }

      .skin-editor .skin.nux-bgcolor {
      background-color: {{NuxColor}} !important;
      color: {{NuxTextColor}} !important;
      }

      .skin-editor .skin.nux-textcolor {
      color: {{NuxTextColor}} !important;
      }

      .skin-editor .skin.nux-bgcolor:after {
      border-top-color: {{NuxColor}} !important;
      }

      .skin-editor .skin.btn-primary {
      background-color: {{PrimaryColor}} !important;
      color: {{PrimaryTextColor}} !important;
      border: 0;
      }

      .skin-editor .skin.primary-button {
      background-color: {{PrimaryColor}} !important;
      color: {{PrimaryTextColor}} !important;
      }

      .skin-editor .skin.right-bg {
      background-color: {{Desktop_Right_Color}} !important;
      color: {{Light_Color_Text}} !important;
      }

      .skin-editor .skin.mobile-right-bg {
      background-color: {{Mobile_Right_Color}} !important;
      color: {{Light_Color_Text}} !important;
      }

      @media (max-width: 768px) {

      .skin-editor .skin.right-bg {
      background-color: {{Mobile_Right_Color}} !important;
      color: {{Light_Color_Text}} !important;
      }
      }

      .skin-editor .skin.primary-bg {
      background-color: {{PrimaryColor}} !important;
      }

      .skin-editor .skin.light-bg {
      background-color: {{LightColor}} !important;
      color: {{Light_Color_Text}} !important;
      }

      .skin-editor .skin.dark-bg {
      background-color: {{DarkColor}} !important;
      color: {{Dark_Color_Text}} !important;
      }

      .skin-editor .skin.medium-bg {
      background-color: {{MediumColor}} !important;
      }

      .skin-editor .vuetable.table tr {
      background-color:initial !important;
      }

      .skin-editor .vuetable.table tr {
      color: {{Light_Color_Text}} !important;
      }

      .skin-editor .skin td {
      border: 0px;
      }

      .vuetable.table {
      border-collapse: separate !important;
      border-spacing: 0px {{Table_Border_Width}}px !important;
      }

      .skin-editor .vuetable.table.skin td {
      background-color: {{LightColor}};
      color: {{Light_Color_Text}} !important;
      }

      .skin-editor .vuetable.table.skin tr.table-active td {
      background-color: {{DarkColor}} !important;
      }

      .skin-editor .vuetable.table.skin tr:hover td {
      background-color: {{DarkColor}} !important;
      }

      .skin-editor .daterangepicker {
      color: black !important;
      }
      .inline .ui-datepicker .ui-datepicker-calendar td a,
      .inline .ui-datepicker .ui-datepicker-prev,
      .inline .ui-datepicker .ui-datepicker-next,
      .inline .ui-datepicker-year,
      .inline .ui-datepicker .ui-datepicker-calendar th {
      color: {{BodyColor}} !important;
      }

      .skin-editor .inline .ui-datepicker .custom-highlight .ui-state-default {
      background-color: {{PrimaryColor}} !important;
      color: {{PrimaryTextColor}} !important;
      border-color: {{BodyColor}} !important;
      }

      .skin-editor table.skin thead tr {
      background-color: initial !important;
      color: {{Light_Color_Text}} !important;
      }

      .skin-editor .typeahead.card-header:hover {
      background-color: {{DarkColor}} !important;
      }

      .skin-editor table.skin thead th {
      }

      .skin-editor .skin.emojionearea {
      border-color: {{DarkColor}} !important;
      outline: 0 !important;
      transition: none !important;
      box-shadow: none !important;
      }

      .skin-editor .day_shift {
      background-color: {{MediumColor}} !important;
      }

      .skin-editor .night_shift {
      background-color: {{MediumColor}} !important;
      }

      .skin-editor .evening_shift {
      background-color: {{MediumColor}} !important;
      }

      .skin-editor .cantwork_shift {
      background-color: {{PrimaryColor}} !important;
      }
      .cantwork_shift_element {
      background-color: {{PrimaryColor}} !important;
      }

      .skin-editor .fc-highlight {
      background-color: {{DarkColor}} !important;
      }

      .skin-editor .fc-button-primary {
      background-color: {{DarkColor}} !important;
      border-color: transparent;
      color: {{Dark_Color_Text}} !important;
      }

      .skin-editor .fc-button-primary.fc-button-active {
      background-color: {{LightColor}} !important;
      border-color: transparent;
      color: {{Light_Color_Text}} !important;
      }

      .skin-editor .fc-daygrid-day-number {
      color: {{Light_Color_Text}} !important;
      }

      .skin-editor .nav-tabs {
      border-color: {{Tabs_Background_Color}} !important;
      background-color: {{Tabs_Background_Color}} !important;
      }

      .skin-editor .nav-tabs .nav-link.active.show {
      background-color: {{Tabs_Active_Color}} !important;
      border-color: {{Tabs_Active_Color}} !important;
      color: {{Light_Color_Text}} !important;
      }

      .skin-editor .nav-tabs .nav-link.active.show i {
      color: {{Light_Color_Text}} !important;
      }

      .skin-editor .nav-tabs .nav-link:hover {
      background-color: rgba(255,255,255,0.2) !important;;
      border-color: rgba(255,255,255,0.2) !important;
      color: {{Tabs_inactive_text_color}} !important;
      }

      .skin-editor .nav-tabs .nav-link {
      background-color: {{Tabs_Inactive_Color}} !important;
      border-color: {{Tabs_Inactive_Color}} !important;
      color: {{Tabs_inactive_text_color}} !important;
      }

      .skin-editor .nav-tabs .nav-link i {
      color: {{Tabs_inactive_text_color}} !important;
      }

      .skin-editor .light-bg.media-chat-item-left:before {
      border-right-color: {{LightColor}} !important;
      }

      .skin-editor .light-bg.media-chat-item-right:before {
      border-left-color: {{LightColor}} !important;
      }

      .skin-editor .dark-bg.media-chat-item-left:before {
      border-right-color: {{DarkColor}} !important;
      }

      .skin-editor .dark-bg.media-chat-item-right:before {
      border-left-color: {{DarkColor}} !important;
      }

      .skin-editor body::-webkit-scrollbar {
      width: 12px;
      }

      .skin-editor body::-webkit-scrollbar-track {
      background: {{DarkColor}};
      }
      .skin-editor body::-webkit-scrollbar-thumb {
      background-color:;
      border-radius: 20px;
      border: 3px solid {{DarkColor}};
      }

      .skin-editor body {
      scrollbar-width: thin;
      scrollbar-color: {{DarkColor}} {{LightColor}};
      }

      .skin-editor .modal-dialog {
      color: black !important;
      }

      .skin-editor .btn-schedule {
      border: 0;
      }

      .skin-editor .shift-border {
      border-color: {{PrimaryColor}} !important;
      }

      .skin-editor .hoverbutton:hover {
      background-color: {{DarkColor}} !important;
      }

      .skin-editor .userscheduletable-container {
      background-color: {{LightColor}};
      color: {{BodyColor}} !important;
      }

      .skin-editor .shifticon {
      border: 2px solid {{BodyColor}} !important;
      }
      .skin-editor .shift-highlight-container {
      border-color: {{BodyColor}} !important;
      }

      .skin-editor .shift-selected-border {
      border: 2px solid {{PrimaryColor}} !important;
      }

      .skin-editor .shift-default-container {
      border: 2px solid transparent !important;
      }

      .skin-editor .shifticon.hasshift {
      background-color: {{DarkColor}} !important;
      }

      .skin-editor .shifticon.noshift {
      background-color: {{PrimaryColor}} !important;
      }

      .skin-editor #viewnotificationContainer .information.card {
      background-color: {{MediumColor}} !important;
      color: {{BodyColor}} !important;
      }

      .skin-editor #viewnotificationContainer .information .card-title {
      background-color: {{News_Info_title_color}} !important;
      color: {{BodyColor}} !important;
      }

      .skin-editor #viewnotificationContainer .discuss.card {
      background-color: {{MediumColor}} !important;
      color: {{BodyColor}} !important;
      }

      .skin-editor #viewnotificationContainer .discuss .card-title {
      background-color: {{News_Discuss_title_color}} !important;
      color: {{BodyColor}} !important;
      }

      .skin-editor #viewnotificationContainer .attention.card {
      background-color: {{MediumColor}} !important;
      color: {{BodyColor}} !important;
      }

      .skin-editor #viewnotificationContainer .attention .card-title {
      background-color: {{News_Attention_title_color}} !important;
      color: {{BodyColor}} !important;
      }

      .skin-editor .mobile-nav-submenubutton {
      background-color: {{MenuMobileColor}} !important;
      color: {{MenuTextColor}} !important;
      min-width:100px;
      }

      .skinnedmenu.dropdown-menu.skin-editor{
      background-color: {{ContextMenuBackgroundColor}} !important;
      }

      .skinnedmenu.skin-editor .dropdown-item{
      color:{{ContextMenuTextColor}}  !important
      }

      .skinnedmenu.dropdown-menu.skin-editor .dropdown-item:focus, .skinnedmenu.dropdown-menu.skin-editor .dropdown-item:hover{
      background-color: {{ContextMenuHoverBackgroundColor}} !important;
      color:{{ContextMenuTextColor}}  !important;
      }


    </component>
    <div class="row">
      <div class="col-8 skin-editor body" style="margin:auto;margin-top:0px;">
        <div style="position:absolute;top:0;right:0; width:100%">
          <ul class="fab-menu fab-menu-top fab-menu-top-right fab-menu-fixed" data-fab-toggle="click" style="margin-top:35px;z-index:10000; right:20px; position:absolute" id="skinMenu" data-fab-state="close">
            <li>
              <button type="button" class="fab-menu-btn btn skin primary-button btn-float rounded-pill btn-icon" @click="toggleExpansion">
                <i class="fab-icon-open icon-plus3"></i>
                <i class="fab-icon-close icon-cross2"></i>
              </button>
            </li>
          </ul>
        </div>
        <div class="row">
          <div class="navbar navbar-expand-md border-transparent shadow-0 px-0 custom-menubar-bg" style="width:100%">
            <div class="container-fluid p-0 px-0 pl-md-4 pr-md-5">
              <div class="navbar-brand wmin-115 d-none d-md-block" style="line-height:initial;font-size:inherit;padding-top:0px;padding-bottom:0px;z-index: 998; min-width:initial">
                <a href="/" class="d-inline-block custom-neutral-item-bg" style="">
                  <img src="/media/hykp34dd/logo_white_black_30x30.png" alt="" style="float:left;margin-top:3px;height:initial;">
                </a>
              </div>
              <ul class="top-menu navbar-nav navbar-nav-highlight navbar-collapse collapse skewed_nav">
                <li class="nav-item">
                  <a href="#" class="navbar-nav-link custom-item-bg active">
                    News
                  </a>
                </li>
                <li class="nav-item">
                  <a href="#" class="navbar-nav-link custom-item-bg ">
                    todo
                  </a>
                </li>
                <li class="nav-item">
                  <a href="#" class="navbar-nav-link custom-item-bg ">
                    Chat
                    <span id="6c7a63lablebadge" class="topnotification badge badge-primary badge-pill float-right" style="top:6px"></span>
                  </a>
                </li>
                <li class="nav-item">
                  <a href="#" class="navbar-nav-link custom-item-bg ">
                    Schedule
                  </a>
                </li>
                <li class="nav-item dropdown show">
                  <a href="#" class="navbar-nav-link custom-item-bg" data-toggle="dropdown" aria-expanded="true"><i class="icon-menu "></i></a>
                  <div class="dropdown-menu show">
                    <a href="#" class="dropdown-item custom-neutral-item-bg "> Procedures</a>
                    <a href="#" class="dropdown-item custom-neutral-item-bg "> Contacts</a>
                    <a href="#" class="dropdown-item custom-neutral-item-bg "> Admin</a>
                    <a href="#" class="dropdown-item custom-neutral-item-bg "> Reports</a>
                    <a href="#" class="dropdown-item custom-neutral-item-bg "> Document Library</a>
                    <a href="#" class="dropdown-item custom-neutral-item-bg "> Skin editor</a>
                  </div>
                </li>
              </ul>
              <ul class="navbar-nav ml-md-auto d-none d-md-block">
                <li class="nav-item dropdown dropdown-lang">
                  <a href="#" class="navbar-nav-link d-flex align-items-center dropdown-toggle custom-neutral-item-bg" data-toggle="dropdown" aria-expanded="false">
                    <span>Home</span>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <a href="/account/SelectSite?site=Home" class="dropdown-item custom-neutral-item-bg"> Home </a>
                    <a href="/account/SelectSite?site=Home1" class="dropdown-item custom-neutral-item-bg"> Home1 </a>
                  </div>
                </li>
              </ul>
              <ul class="navbar-nav ml-md-auto d-none d-md-block">
                <li class="nav-item dropdown dropdown-user">
                  <a href="#" class="navbar-nav-link d-flex align-items-center dropdown-toggle custom-neutral-item-bg" data-toggle="dropdown" aria-expanded="false">
                    <img src="/api/membership/GetSquareImage?username=erikbohm@hotmail.com" class="rounded-circle mr-2" alt="" width="34" height="34">
                    <span>Erik 6</span>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <a href="javascript:void(0)" class="dropdown-item custom-neutral-item-bg"><i class="icon-cog5"></i> Profile settings</a>
                    <a href="javascript:void(0)" class="dropdown-item custom-item-bg"><i class="icon-switch2"></i> Logout</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 p-0">
            <panels ref="skinEditorPanels">
              <template slot="main" scope="childDataScope">
                <div id="someother" class="p-0 m-0 px-2 pt-3" style="height:500px;overflow-y:auto">
                  <div class="row p-0 m-0">
                    <div class="col-12 p-0 m-0" style="height:400px;">
                      <basic-table ref="mockupTable" rowclick="doRowClick" menuclass="skin-editor" enableedit="true" tablecss="skin">
                        <template slot="menu" scope="childDataScope">
                          <a href="#" class="dropdown-item">Copy</a>
                          <a href="#" class="dropdown-item">Delete</a>
                          <a href="#" class="dropdown-item">Edit</a>
                        </template>
                      </basic-table>
                    </div>
                  </div>
                  <div class="row" style="position: absolute; width: 100%; bottom: 62px;">
                    <div class="col-12 p-0">
                      <div class="speech-bubble p-2 skin nux-bgcolor nux-textcolor " style="">
                        <div class="row">
                          <div class="col p-2 displaytext">
                            This is the NUX text...
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template slot="right" scope="childDataScope">
                <div id="someContainer" class="tab-pane fade show active p-0 skin right-bg" style="border-left: 1px solid #DCDDDE !important; height: 100%">
                  <ul id="procedureTabsX" class="nav nav-tabs nav-tabs-highlight mb-0 mr-0">
                    <li class="nav-item" style="border-left-width: 0px !important;">
                      <a href="#skin-editor-Panel1" data-toggle="tab" class="nav-link active show" style="border-left-width: 0px;">
                        <i class="icon-stack-check"></i>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="#skin-editor-Panel2" data-toggle="tab" class="nav-link" style="">
                        <i class="icon-pencil7"></i>
                      </a>
                    </li>
                  </ul>
                  <div class="tab-content border-top-0 rounded-top-0 mb-0" style="height: 100%;">
                    <div id="skin-editor-Panel1" class="tab-pane fade active show p-2" style="height: 100%;">
                      Panel 1
                    </div>
                    <div id="skin-editor-Panel2" class="tab-pane fade p-2" style="">
                      Panel 2
                    </div>
                  </div>
                </div>
              </template>
            </panels>
          </div>
        </div>
        

      </div>
      <div class="col-4 pb-5" style="height:500px; overflow-y:auto;">

        <div class="col-12 custom-form-label">
          Published ({{Published}})
        </div>
        <div class="col-12 mt-1">

          <div class="custom-control custom-checkbox custom-control-inline">
            <input class="custom-control-input chk-task-success" name="check_published" id="check_published" type="checkbox" v-model="Published" v-bind:checked="Published == true" />
            <label class="custom-control-label chk-task-success" for="check_published">
              Published
            </label>
          </div>
        </div>
        <div class="col-12 mt-3 custom-form-label">
          Name ({{Name}})
        </div>
        <div class="col-12 mt-1">
          <input type="text" class="form-control" v-model="Name" />
        </div>

        <container-expand-right title="Background" class="p-2">
          <div class="card p-3">
            <div class="col-12 mt-1 custom-form-label">
              BackGroundImage ({{BackGroundImage}})
            </div>
            <div class="col-12 mt-1">
              <input id="backGroundImageInput" type="text" class="form-control col-10" v-model="BackGroundImage" style="float:left;" />
              <upload-button @change="changeBackgroundImage" class="col-2" style="float:right;"></upload-button>
            </div>

            <div class="col-12 mt-1 custom-form-label">
              BackGroundColor ({{BackGroundColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-bind:value="BackGroundColor" v-model="BackGroundColor" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              BodyColor ({{BodyColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="BodyColor" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              Mobile_Right_Color ({{Mobile_Right_Color}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="Mobile_Right_Color" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              Desktop_Right_Color ({{Desktop_Right_Color}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="Desktop_Right_Color" />
            </div>

          </div>
        </container-expand-right>

        <container-expand-right title="Menu" class="p-2">
          <div class="card p-3">


            <div class="col-12 mt-1 custom-form-label">
              TopMenuBackColor ({{TopMenuBackColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="TopMenuBackColor" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              MenuColor ({{MenuColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="MenuColor" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              MenuActiveColor ({{MenuActiveColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="MenuActiveColor" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              TopMenuDropBackColor ({{TopMenuDropBackColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="TopMenuDropBackColor" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              MenuMobileColor ({{MenuMobileColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="MenuMobileColor" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              MenuMobileSubColor ({{MenuMobileSubColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="MenuMobileSubColor" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              MenuTextColor ({{MenuTextColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="MenuTextColor" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              MenuActiveTextColor ({{MenuActiveTextColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="MenuActiveTextColor" />
            </div>

          </div>
        </container-expand-right>





        <container-expand-right title="Nux" class="p-2">
          <div class="card p-3">
            <div class="col-12 mt-1 custom-form-label">
              NuxColor ({{NuxColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="NuxColor" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              NuxTextColor ({{NuxTextColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="NuxTextColor" />
            </div>
          </div>
        </container-expand-right>



        <container-expand-right title="Standard colors" class="p-2">
          <div class="card p-3">

            <div class="col-12 mt-1 custom-form-label">
              LightColor ({{LightColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="LightColor" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              PrimaryColor ({{PrimaryColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="PrimaryColor" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              PrimaryTextColor ({{PrimaryTextColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="PrimaryTextColor" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              MediumColor ({{MediumColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="MediumColor" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              DarkColor ({{DarkColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="DarkColor" />
            </div>


            <div class="col-12 mt-1 custom-form-label">
              Light_Color_Text ({{Light_Color_Text}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="Light_Color_Text" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              Dark_Color_Text ({{Dark_Color_Text}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="Dark_Color_Text" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              SecondaryHighlightColor ({{SecondaryHighlightColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="SecondaryHighlightColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              SecondaryHighlightTextColor ({{SecondaryHighlightTextColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="SecondaryHighlightTextColor" />
            </div>


            <div class="col-12 mt-3 custom-form-label">
              PanelDividorBorderColor ({{PanelDividorBorderColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="PanelDividorBorderColor" />
            </div>



          </div>
        </container-expand-right>







        <container-expand-right title="Table" class="p-2">
          <div class="card p-3">


            <div class="col-12 mt-1 custom-form-label" style="display:none;">
              Table_Border_Color ({{Table_Border_Color}})
            </div>
            <div class="col-12 mt-1" style="display:none;">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="Table_Border_Color" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              Table_Border_Width ({{Table_Border_Width}})
            </div>
            <div class="col-12 mt-1">
              <input type="text" class="form-control" v-model="Table_Border_Width" />
            </div>

          </div>
        </container-expand-right>

        <container-expand-right title="Admin" class="p-2">
          <div class="card p-3">
            <div class="col-12 mt-1 custom-form-label">
              Admin_Menu_Color ({{Admin_Menu_Color}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="Admin_Menu_Color" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              Admin_Menu_Selected_Color ({{Admin_Menu_Selected_Color}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="Admin_Menu_Selected_Color" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              MobileExpandOverLayColor ({{MobileExpandOverLayColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="MobileExpandOverLayColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              AdminMenuTextColor ({{AdminMenuTextColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="AdminMenuTextColor" />
            </div>

          </div>
        </container-expand-right>


        <container-expand-right title="Tabs" class="p-2">
          <div class="card p-3">
            <div class="col-12 mt-1 custom-form-label">
              Tabs_Background_Color ({{Tabs_Background_Color}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="Tabs_Background_Color" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              Tabs_Inactive_Color ({{Tabs_Inactive_Color}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="Tabs_Inactive_Color" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              Tabs_Active_Color ({{Tabs_Active_Color}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="Tabs_Active_Color" />
            </div>


            <div class="col-12 mt-1 custom-form-label">
              Tabs_active_text_color ({{Tabs_active_text_color}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="Tabs_active_text_color" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              Tabs_active_text_color ({{Tabs_inactive_text_color}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="Tabs_inactive_text_color" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              Tabs_inactive_text_color ({{Tabs_inactive_text_color}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="Tabs_inactive_text_color" />
            </div>


          </div>
        </container-expand-right>




        <container-expand-right title="News page" class="p-2">
          <div class="card p-3">
            <div class="col-12 mt-1 custom-form-label">
              News_Info_title_color ({{News_Info_title_color}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="News_Info_title_color" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              News_Discuss_title_color ({{News_Discuss_title_color}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="News_Discuss_title_color" />
            </div>

            <div class="col-12 mt-1 custom-form-label">
              News_Attention_title_color ({{News_Attention_title_color}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="News_Attention_title_color" />
            </div>
          </div>
        </container-expand-right>



        <container-expand-right title="Right menu" class="p-2">
          <div class="card p-3">
            <div class="col-12 mt-1 custom-form-label">
              ContextMenuBackgroundColor ({{ContextMenuBackgroundColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="ContextMenuBackgroundColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              ContextMenuHoverBackgroundColor ({{ContextMenuHoverBackgroundColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="ContextMenuHoverBackgroundColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              ContextMenuTextColor ({{ContextMenuTextColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="ContextMenuTextColor" />
            </div>
          </div>
        </container-expand-right>


        <div class="col-12 mt-3 custom-form-label">
          NewsFillColor ({{NewsFillColor}})
        </div>
        <div class="col-12 mt-1">
          <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="NewsFillColor" />
        </div>














        <container-expand-right title="Forms" class="p-2">
          <div class="card p-3">

            <div class="col-12 mt-3 custom-form-label">
              InputBackgroundColor ({{InputBackgroundColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="InputBackgroundColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              InputBorderColor ({{InputBorderColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="InputBorderColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              InputFocusBackgroundColor ({{InputFocusBackgroundColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="InputFocusBackgroundColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              InputFocusBorderColor ({{InputFocusBorderColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="InputFocusBorderColor" />
            </div>
          </div>
        </container-expand-right>



        <container-expand-right title="Onboarding (not used)" class="p-2">
          <div class="card p-3">
            <div class="col-12 mt-3 custom-form-label">
              OnboardingBackgroundColor ({{OnboardingBackgroundColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="OnboardingBackgroundColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              OnboardingQuestionBackgroundColor ({{OnboardingQuestionBackgroundColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="OnboardingQuestionBackgroundColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              OnboardingQuestionTextColor ({{OnboardingQuestionTextColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="OnboardingQuestionTextColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              OnboardingAnswerBackgroundColor ({{OnboardingAnswerBackgroundColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="OnboardingAnswerBackgroundColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              OnboardingAnswerTextColor ({{OnboardingAnswerTextColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="OnboardingAnswerTextColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              OnboardingAnswerAltBackgroundColor ({{OnboardingAnswerAltBackgroundColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="OnboardingAnswerAltBackgroundColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              OnboardingAnswerAltTextColor ({{OnboardingAnswerAltTextColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="OnboardingAnswerAltTextColor" />
            </div>
          </div>
        </container-expand-right>



        <container-expand-right title="Buttons (not used)" class="p-2">
          <div class="card p-3">
            <div class="col-12 mt-3 custom-form-label">
              DoneBackgroundColor ({{DoneBackgroundColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="DoneBackgroundColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              NotDoneBackgroundColor ({{NotDoneBackgroundColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="NotDoneBackgroundColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              ButtonSuccessBackgroundColor ({{ButtonSuccessBackgroundColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="ButtonSuccessBackgroundColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              ButtonWarningBackgroundColor ({{ButtonWarningBackgroundColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="ButtonWarningBackgroundColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              ButtonCancelBackgroundColor ({{ButtonCancelBackgroundColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="ButtonCancelBackgroundColor" />
            </div>

            <div class="col-12 mt-3 custom-form-label">
              ButtonTextColor ({{ButtonTextColor}})
            </div>
            <div class="col-12 mt-1">
              <input id="dsdssdds" v-on="listeners" type="text" class="form-control colorpicker-palette-toggle2" data-fouc="" v-model="ButtonTextColor" />
            </div>
          </div>
        </container-expand-right>


        <container-expand-right title="Empty (not used)" class="p-2">
          <div class="card p-3">

          </div>
        </container-expand-right>

        <div class="row px-3 mt-3">
          <div class="col-12 p-0">
            <button class="btn btn-light" @click="exportData()">Export</button>
            <button class="btn btn-light ml-2" @click="importData()">Import</button>
          </div>
        </div>

        <div class="row px-3 mt-3">
          <div class="col-12 p-0">
            <textarea class="form-control" v-model="importTxt"></textarea>
          </div>
        </div>




      </div>
    </div>
  </div>
</template>

<script>

  import UploadButton from "../upload/upload-button.vue";

  export default {
    name: 'skin-editor',
    components: {
      UploadButton
    },

    data() {
      return {
        importTxt:"",
        Published:false,
        SkinId: -1,
        Name:'',
        Tabs_active_text_color: 'black',
        Tabs_inactive_text_color: '#6c6c6c',
        TopMenuDropBackColor: 'black',
        TopMenuBackColor: 'black',
        MenuMobileColor: 'black',
        MenuMobileSubColor: 'black',
        MenuColor: 'black',
        NuxColor: 'pink',
        NuxTextColor: 'white',
        LightColor: '#F6F7F7',
        PrimaryColor: '#03a9f4',
        PrimaryTextColor: 'white',
        MediumColor: '#EAEAEA',
        DarkColor: 'rgb(220, 221, 221)',
        MenuTextColor: 'white',
        MenuActiveColor: '#393939',
        MenuActiveTextColor: 'white',
        BackGroundImage: '/images/backgrounds/power.jpg',
        BackGroundColor: 'white',
        BodyColor: 'black',
        Light_Color_Text: 'black',
        Dark_Color_Text: 'black',
        Mobile_Right_Color: 'white',
        Desktop_Right_Color: 'white',
        Table_Border_Color: 'white',
        Admin_Menu_Color: '#F3F2F1',
        Admin_Menu_Selected_Color: 'white',
        Tabs_Background_Color: 'rgb(220, 221, 221)',
        Tabs_Inactive_Color: '#EAEAEA',
        Tabs_Active_Color: '#F6F7F7',
        Table_Border_Width: '5',
        News_Info_title_color: '#DAE7C2',
        News_Discuss_title_color: '#57C2D4',
        News_Attention_title_color: '#EE7A30',
        ContextMenuBackgroundColor: 'white',
        ContextMenuHoverBackgroundColor: '#f7f7f7',
        ContextMenuTextColor: 'black',

        NewsFillColor: 'white',
        SecondaryHighlightColor: 'red',
        SecondaryHighlightTextColor: 'white',
        InputBackgroundColor: 'white',
        InputBorderColor: '#dddddd',
        InputFocusBackgroundColor: 'white',
        InputFocusBorderColor: '#2196f3',
        PanelDividorBorderColor: 'white',
        MobileExpandOverLayColor: 'rgba(255,255,255,0.5)',

        AdminMenuTextColor: 'black',
        DoneBackgroundColor: '#25B372',
        NotDoneBackgroundColor: '#F58646',
        ButtonSuccessBackgroundColor: '#03A9F4',
        ButtonWarningBackgroundColor: '#F58646',
        ButtonCancelBackgroundColor: '#DCDDDD',
        ButtonTextColor: 'white',
        OnboardingBackgroundColor: 'white',

        OnboardingQuestionBackgroundColor: 'blue',
        OnboardingQuestionTextColor: 'white',
        OnboardingAnswerBackgroundColor: 'green',
        OnboardingAnswerTextColor: 'white',
        OnboardingAnswerAltBackgroundColor: 'blue',
        OnboardingAnswerAltTextColor: 'white',




      }
    },

   

    props: {

    },
    methods:
    {
      exportData() {
        this.importTxt = JSON.stringify(this.getData());
      },
      importData() {
        var data = JSON.parse(this.importTxt);
        this.populateData(data);
      },
      changeBackgroundImage(url, name, settings) {
        $("#backGroundImageInput").val(url)
        var e = document.createEvent('HTMLEvents');
        e.initEvent('input', true, true);
        $("#backGroundImageInput")[0].dispatchEvent(e);
      },
      toggleExpansion() {
        //alert("toggleExpansion");
        if (!this.$refs.skinEditorPanels.isExpanded()) {
          this.$refs.skinEditorPanels.showRight();
        }
        else {
          this.$refs.skinEditorPanels.hideRight();
        }
      },
      populateData(skin) {
        this.Name = skin.Name;
        this.Published = skin.Published;
        this.Tabs_active_text_color = skin.Tabs_active_text_color;
        this.Tabs_inactive_text_color = skin.Tabs_inactive_text_color;
        this.TopMenuDropBackColor = skin.TopMenuDropBackColor;
        this.TopMenuBackColor = skin.TopMenuBackColor;
        this.MenuMobileColor = skin.MenuMobileColor;
        this.MenuMobileSubColor = skin.MenuMobileSubColor;
        this.MenuColor = skin.MenuColor;
        this.NuxColor = skin.NuxColor;
        this.NuxTextColor = skin.NuxTextColor;
        this.LightColor = skin.LightColor;
        this.PrimaryColor = skin.PrimaryColor;
        this.PrimaryTextColor = skin.PrimaryTextColor;
        this.MediumColor = skin.MediumColor;
        this.DarkColor = skin.DarkColor;
        this.MenuTextColor = skin.MenuTextColor;
        this.MenuActiveColor = skin.MenuActiveColor;
        this.MenuActiveTextColor = skin.MenuActiveTextColor;
        this.BackGroundImage = skin.BackGroundImage;
        this.BackGroundColor = skin.BackGroundColor;
        this.BodyColor = skin.BodyColor;
        this.Light_Color_Text = skin.Light_Color_Text;
        this.Dark_Color_Text = skin.Dark_Color_Text;
        this.Mobile_Right_Color = skin.Mobile_Right_Color;
        this.Desktop_Right_Color = skin.Desktop_Right_Color;
        this.Table_Border_Color = skin.Table_Border_Color;
        this.Admin_Menu_Color = skin.Admin_Menu_Color;
        this.Admin_Menu_Selected_Color = skin.Admin_Menu_Selected_Color;
        this.Tabs_Background_Color = skin.Tabs_Background_Color;
        this.Tabs_Inactive_Color = skin.Tabs_Inactive_Color;
        this.Tabs_Active_Color = skin.Tabs_Active_Color;
        this.Table_Border_Width = skin.Table_Border_Width;
        this.News_Info_title_color = skin.News_Info_title_color;
        this.News_Discuss_title_color = skin.News_Discuss_title_color;
        this.News_Attention_title_color = skin.News_Attention_title_color;

        this.ContextMenuBackgroundColor = skin.ContextMenuBackgroundColor;
        this.ContextMenuHoverBackgroundColor = skin.ContextMenuHoverBackgroundColor;
        this.ContextMenuTextColor = skin.ContextMenuTextColor;

        this.NewsFillColor = skin.NewsFillColor;
        this.SecondaryHighlightColor = skin.SecondaryHighlightColor;
        this.SecondaryHighlightTextColor = skin.SecondaryHighlightTextColor;
        this.InputBackgroundColor = skin.InputBackgroundColor;

        this.InputBorderColor = skin.InputBorderColor;
        this.InputFocusBackgroundColor = skin.InputFocusBackgroundColor;
        this.InputFocusBorderColor = skin.InputFocusBorderColor;
        this.PanelDividorBorderColor = skin.PanelDividorBorderColor;

        this.MobileExpandOverLayColor = skin.MobileExpandOverLayColor;


        this.AdminMenuTextColor = skin.AdminMenuTextColor;
        this.DoneBackgroundColor = skin.DoneBackgroundColor;
        this.NotDoneBackgroundColor = skin.NotDoneBackgroundColor;
        this.ButtonSuccessBackgroundColor = skin.ButtonSuccessBackgroundColor;
        this.ButtonWarningBackgroundColor = skin.ButtonWarningBackgroundColor;
        this.ButtonCancelBackgroundColor = skin.ButtonCancelBackgroundColor;
        this.ButtonTextColor = skin.ButtonTextColor;
        this.OnboardingBackgroundColor = skin.OnboardingBackgroundColor;
        this.OnboardingQuestionBackgroundColor = skin.OnboardingQuestionBackgroundColor;
        this.OnboardingQuestionTextColor = skin.OnboardingQuestionTextColor;
        this.OnboardingAnswerBackgroundColor = skin.OnboardingAnswerBackgroundColor;
        this.OnboardingAnswerTextColor = skin.OnboardingAnswerTextColor;
        this.OnboardingAnswerAltBackgroundColor = skin.OnboardingAnswerAltBackgroundColor;
        this.OnboardingAnswerAltTextColor = skin.OnboardingAnswerAltTextColor;

        var thisContext = this;

        this.$forceUpdate();

        setTimeout(function () {
          thisContext.resetColorPicker();
        }, 200);

      },
      loadSkin(id) {
        this.SkinId = id;
        try {
          this.$http.get('/api/Skin/GetSkin?id=' + id).then(async response => {
            var skin = response.data;

            this.populateData(skin);

           

          });
        } catch (err) {
          alert('some error:' + err)
        }
      },

      getData() {
        var data =
        {
          Id: this.SkinId,
          Name: this.Name,
          Published: this.Published,
          Tabs_active_text_color: this.Tabs_active_text_color,
          Tabs_inactive_text_color: this.Tabs_inactive_text_color,
          TopMenuDropBackColor: this.TopMenuDropBackColor,
          TopMenuBackColor: this.TopMenuBackColor,
          MenuMobileColor: this.MenuMobileColor,
          MenuMobileSubColor: this.MenuMobileSubColor,
          MenuColor: this.MenuColor,
          NuxColor: this.NuxColor,
          NuxTextColor: this.NuxTextColor,
          LightColor: this.LightColor,
          PrimaryColor: this.PrimaryColor,
          PrimaryTextColor: this.PrimaryTextColor,
          MediumColor: this.MediumColor,
          DarkColor: this.DarkColor,
          MenuTextColor: this.MenuTextColor,
          MenuActiveColor: this.MenuActiveColor,
          MenuActiveTextColor: this.MenuActiveTextColor,
          BackGroundImage: this.BackGroundImage,
          BackGroundColor: this.BackGroundColor,
          BodyColor: this.BodyColor,
          Light_Color_Text: this.Light_Color_Text,
          Dark_Color_Text: this.Dark_Color_Text,
          Mobile_Right_Color: this.Mobile_Right_Color,
          Desktop_Right_Color: this.Desktop_Right_Color,
          Table_Border_Color: this.Table_Border_Color,
          Admin_Menu_Color: this.Admin_Menu_Color,
          Admin_Menu_Selected_Color: this.Admin_Menu_Selected_Color,
          Tabs_Background_Color: this.Tabs_Background_Color,
          Tabs_Inactive_Color: this.Tabs_Inactive_Color,
          Tabs_Active_Color: this.Tabs_Active_Color,
          Table_Border_Width: this.Table_Border_Width,
          News_Info_title_color: this.News_Info_title_color,
          News_Discuss_title_color: this.News_Discuss_title_color,
          News_Attention_title_color: this.News_Attention_title_color,

          ContextMenuBackgroundColor: this.ContextMenuBackgroundColor,
          ContextMenuHoverBackgroundColor: this.ContextMenuHoverBackgroundColor,
          ContextMenuTextColor: this.ContextMenuTextColor,


          NewsFillColor: this.NewsFillColor,

          SecondaryHighlightColor: this.SecondaryHighlightColor,
          SecondaryHighlightTextColor: this.SecondaryHighlightTextColor,
          InputBackgroundColor: this.InputBackgroundColor,
          InputBorderColor: this.InputBorderColor,
          InputFocusBackgroundColor: this.InputFocusBackgroundColor,
          InputFocusBorderColor: this.InputFocusBorderColor,
          PanelDividorBorderColor: this.PanelDividorBorderColor,
          MobileExpandOverLayColor: this.MobileExpandOverLayColor,
          

          AdminMenuTextColor : this.AdminMenuTextColor,
          DoneBackgroundColor : this.DoneBackgroundColor,
          NotDoneBackgroundColor : this.NotDoneBackgroundColor,
          ButtonSuccessBackgroundColor : this.ButtonSuccessBackgroundColor,
          ButtonWarningBackgroundColor : this.ButtonWarningBackgroundColor,
          ButtonCancelBackgroundColor : this.ButtonCancelBackgroundColor,
          ButtonTextColor : this.ButtonTextColor,
          OnboardingBackgroundColor : this.OnboardingBackgroundColor,
          OnboardingQuestionBackgroundColor : this.OnboardingQuestionBackgroundColor,
          OnboardingQuestionTextColor : this.OnboardingQuestionTextColor,
          OnboardingAnswerBackgroundColor : this.OnboardingAnswerBackgroundColor,
          OnboardingAnswerTextColor : this.OnboardingAnswerTextColor,
          OnboardingAnswerAltBackgroundColor : this.OnboardingAnswerAltBackgroundColor,
          OnboardingAnswerAltTextColor : this.OnboardingAnswerAltTextColor,


        }
        return data;
      },
       populateMockupTable(){

        var headerdata = [
          { headername: "Something", columnname: "Id", css: "", datahide: "", enabled: true, databreakpoints: "" },
          { headername: "A name", columnname: "Name", css: "", datahide: "", enabled: true, databreakpoints: "" },
        ];

        var tabledata = [{ Id: 1, Name: "somthing" }, { Id: 2, Name: "Something else" }]

        this.$refs.mockupTable.setData(headerdata, tabledata);
         this.$refs.mockupTable.render();


      },

      resetColorPicker() {

        var demoPalette = [
          ["#000", "#444", "#666", "#999", "#ccc", "#eee", "#f3f3f3", "#fff"],
          ["#f00", "#f90", "#ff0", "#0f0", "#0ff", "#00f", "#90f", "#f0f"],
          ["#f4cccc", "#fce5cd", "#fff2cc", "#d9ead3", "#d0e0e3", "#cfe2f3", "#d9d2e9", "#ead1dc"],
          ["#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8", "#a2c4c9", "#9fc5e8", "#b4a7d6", "#d5a6bd"],
          ["#e06666", "#f6b26b", "#ffd966", "#93c47d", "#76a5af", "#6fa8dc", "#8e7cc3", "#c27ba0"],
          ["#c00", "#e69138", "#f1c232", "#6aa84f", "#45818e", "#3d85c6", "#674ea7", "#a64d79"],
          ["#900", "#b45f06", "#bf9000", "#38761d", "#134f5c", "#0b5394", "#351c75", "#741b47"],
          ["#600", "#783f04", "#7f6000", "#274e13", "#0c343d", "#073763", "#20124d", "#4c1130"]
        ]

        $('.colorpicker-palette-toggle2').spectrum({
          showPalette: true,
          showPaletteOnly: false,
          togglePaletteMoreText: 'More',
          togglePaletteLessText: 'Less',
          palette: demoPalette,
          preferredFormat: "hex",
          cancelText: 'Cancel',
          chooseText: 'Choose',
          showInput: true,
          clickoutFiresChange: true,
          showAlpha: true,
        });
      }
      

    },
    created() {
      
    },
    mounted() {

      this.populateMockupTable();

     
      $(".colorpicker-palette-toggle2").on('change.spectrum', function (e, tinycolor) {
        $(this).val(tinycolor.toRgbString())
        var e = document.createEvent('HTMLEvents');
        e.initEvent('input', true, true);
        this.dispatchEvent(e);
      });
      

      $(".colorpicker-palette-toggle2").on('move.spectrum', function (e, tinycolor) {
        $(this).val(tinycolor.toRgbString())
        var e = document.createEvent('HTMLEvents');
        e.initEvent('input', true, true);
        this.dispatchEvent(e);
      });


      
      //$('.colorpicker-palette-toggle2').on('input',
      //  function () {
      //    alert('changed')
      //    $(this).val()
      //  }
      //);

      

      
      //$('.colorpicker-palette-toggle').spectrum("enable");

    },
    computed: {
    },
}
</script>



// WEBPACK FOOTER //
// src/components/skin-editor/skin-editor.vue